export type Filter = {
    name: string|null,
    category: string|null
}

export const emptyFilter: Filter = {
    name: null,
    category: null
}